module.exports = __webpack_public_path__ + "static/media/HR-Reports-Template.895e5e5f.png";